var map = {
	"./ar-SA.json": [
		1284,
		8
	],
	"./be-BY.json": [
		1285,
		9
	],
	"./bn-BD.json": [
		1286,
		10
	],
	"./cs-CZ.json": [
		1287,
		11
	],
	"./da-DK.json": [
		1288,
		12
	],
	"./de-DE.json": [
		1289,
		13
	],
	"./el-GR.json": [
		1290,
		14
	],
	"./en-GB.json": [
		1291,
		15
	],
	"./en-US.json": [
		1292,
		16
	],
	"./es-ES.json": [
		1293,
		17
	],
	"./fi-FI.json": [
		1294,
		18
	],
	"./fr-FR.json": [
		1295,
		19
	],
	"./he-IL.json": [
		1296,
		20
	],
	"./hi-IN.json": [
		1297,
		21
	],
	"./hr-HR.json": [
		1298,
		22
	],
	"./hu-HU.json": [
		1299,
		23
	],
	"./id-ID.json": [
		1300,
		24
	],
	"./it-IT.json": [
		1301,
		25
	],
	"./ja-JP.json": [
		1302,
		26
	],
	"./km-KH.json": [
		1303,
		27
	],
	"./ko-KR.json": [
		1304,
		28
	],
	"./me-ME.json": [
		1305,
		29
	],
	"./ne-NP.json": [
		1306,
		30
	],
	"./nl-NL.json": [
		1307,
		31
	],
	"./no-NO.json": [
		1308,
		32
	],
	"./pl-PL.json": [
		1309,
		33
	],
	"./pt-BR.json": [
		1310,
		34
	],
	"./pt-PT.json": [
		1311,
		35
	],
	"./ro-RO.json": [
		1312,
		36
	],
	"./ru-MD.json": [
		1313,
		37
	],
	"./ru-RU.json": [
		1314,
		38
	],
	"./sh-HR.json": [
		1315,
		39
	],
	"./si-LK.json": [
		1316,
		40
	],
	"./sk-SK.json": [
		1317,
		41
	],
	"./sr-CS.json": [
		1318,
		42
	],
	"./sr-ME.json": [
		1319,
		43
	],
	"./sr-RS.json": [
		1320,
		44
	],
	"./sr-SP.json": [
		1321,
		45
	],
	"./src/cboard.json": [
		1322,
		46
	],
	"./sv-SE.json": [
		1323,
		47
	],
	"./th-TH.json": [
		1324,
		48
	],
	"./tr-TR.json": [
		1325,
		49
	],
	"./uk-UA.json": [
		1326,
		50
	],
	"./ur-PK.json": [
		1327,
		51
	],
	"./vi-VN.json": [
		1328,
		52
	],
	"./zh-CN.json": [
		1329,
		53
	],
	"./zu-ZA.json": [
		1330,
		54
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1017;
module.exports = webpackAsyncContext;